module.exports = __webpack_public_path__ + "static/media/meeting-team.2bf8d02c.png";